import { checkEnvironment } from '@saviynt/common';

const postCredentialRequestUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/request/access/`;
};

export default postCredentialRequestUrl;
